export interface Movie {
  id: string;
  title: string;
  type: "tv" | "movie" | "variety";
  typeName: string;
  cover: string;
  year: number;
  region: string;
  rating: number;
  genres: string[];
  actors: string[];
  director: string;
  description: string;
  episodes: number;
  updatedAt: string;
  views: number;
  hot: boolean;
}

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "kuangbiao",
    title: "狂飙",
    subtitle: "二十年黑白较量，一部扫黑题材的现象级国民大剧",
    tag: "热播大剧",
    image: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20crime%20drama%20backdrop%2C%20moody%20night%20city%20skyline%20with%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20charcoal%20and%20warm%20amber%20lighting%2C%20atmospheric%20fog%2C%20dramatic%20film%20noir%20composition%2C%20high%20detail%20cinematic%20key%20art&width=1600&height=900&seq=hero-kuangbiao-01&orientation=landscape"
  },
  {
    id: "wandering-earth-2",
    title: "流浪地球2",
    subtitle: "人类命运共同体，中国科幻电影的里程碑之作",
    tag: "科幻巨制",
    image: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%2C%20giant%20planet%20engine%20towering%20above%20frozen%20earth%2C%20orange%20and%20teal%20cinematic%20color%20grading%2C%20vast%20cosmic%20scale%2C%20dramatic%20lighting%20and%20lens%20flares%2C%20futuristic%20surreal%20atmosphere%2C%20premium%20movie%20poster%20art&width=1600&height=900&seq=hero-wandering-earth-02&orientation=landscape"
  },
  {
    id: "three-body",
    title: "三体",
    subtitle: "宇宙就是一座黑暗森林，每个文明都是带枪的猎人",
    tag: "硬核科幻",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20space%20telescope%20scene%2C%20deep%20starfield%20with%20red%20giant%20sun%20and%20three%20orbiting%20planets%2C%20dark%20navy%20and%20crimson%20tones%2C%20eerie%20cosmic%20atmosphere%2C%20cinematic%20scientific%20aesthetic%2C%20high%20detail%20key%20art&width=1600&height=900&seq=hero-three-body-03&orientation=landscape"
  },
  {
    id: "man-jiang-hong",
    title: "满江红",
    subtitle: "层层反转的悬疑迷局，张艺谋的东方美学尝试",
    tag: "悬疑古装",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ancient%20courtyard%20at%20night%2C%20red%20lanterns%20and%20misty%20stone%20corridors%2C%20deep%20crimson%20and%20ink%20black%20palette%2C%20mysterious%20suspenseful%20mood%2C%20cinematic%20wuxia%20aesthetic%2C%20elegant%20oriental%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-manjianghong-04&orientation=landscape"
  }
];

export const movies: Movie[] = [
  {
    id: "kuangbiao",
    title: "狂飙",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20poster%2C%20serious%20Chinese%20man%20in%20dark%20coat%20standing%20in%20moody%20city%20alley%2C%20charcoal%20and%20amber%20tones%2C%20dramatic%20side%20lighting%2C%20gritty%20film%20noir%20atmosphere%2C%20minimal%20dark%20background%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-kuangbiao&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 9.1,
    genres: ["犯罪", "悬疑", "剧情"],
    actors: ["张译", "张颂文", "李一桐"],
    director: "徐纪周",
    description: "以一线刑警安欣与黑恶势力代表人物高启强长达二十年的正邪较量为主线，全景式展现扫黑除恶专项斗争中的惊心动魄与人性挣扎，被誉为近年国产剧的现实主义高峰。",
    episodes: 39,
    updatedAt: "2024-01-18",
    views: 9820000,
    hot: true
  },
  {
    id: "wandering-earth-2",
    title: "流浪地球2",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20astronaut%20silhouette%20before%20a%20giant%20glowing%20planet%20engine%2C%20deep%20blue%20and%20orange%20gradient%20sky%2C%20cinematic%20dramatic%20lighting%2C%20cosmic%20scale%2C%20minimal%20dark%20background%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-wandering-earth-2&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 8.3,
    genres: ["科幻", "灾难", "剧情"],
    actors: ["吴京", "刘德华", "李雪健"],
    director: "郭帆",
    description: "太阳危机迫近，人类启动流浪地球计划。面对月球坠落与数字生命的抉择，中国航天员与全球同行共同书写人类文明的存续之战，视觉奇观与情感浓度兼具。",
    episodes: 1,
    updatedAt: "2024-02-02",
    views: 8650000,
    hot: true
  },
  {
    id: "three-body",
    title: "三体",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Sci-fi%20series%20poster%2C%20lonely%20figure%20gazing%20at%20a%20vast%20starfield%20with%20red%20sun%2C%20dark%20navy%20and%20crimson%20palette%2C%20mysterious%20cosmic%20atmosphere%2C%20cinematic%20lighting%2C%20minimal%20dark%20background%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-three-body&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 8.7,
    genres: ["科幻", "悬疑", "剧情"],
    actors: ["张鲁一", "于和伟", "陈瑾"],
    director: "杨磊",
    description: "纳米科学家汪淼与刑警史强联手调查科学家连环自杀之谜，逐步揭开三体文明与地球文明跨越四百年的生死博弈，被赞为最忠于原著的影视改编。",
    episodes: 30,
    updatedAt: "2024-01-25",
    views: 7420000,
    hot: true
  },
  {
    id: "man-jiang-hong",
    title: "满江红",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20ancient%20suspense%20movie%20poster%2C%20warrior%20in%20traditional%20armor%20in%20misty%20courtyard%2C%20deep%20crimson%20and%20ink%20black%20palette%2C%20dramatic%20lantern%20lighting%2C%20mysterious%20oriental%20atmosphere%2C%20minimal%20dark%20background%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-manjianghong&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 7.0,
    genres: ["悬疑", "喜剧", "古装"],
    actors: ["沈腾", "易烊千玺", "张译"],
    director: "张艺谋",
    description: "南宋绍兴年间，小兵张大与亲兵营副统领孙均在一夜之间被卷入一场惊天迷局。层层反转的情节与类型混搭的叙事，成为春节档的话题之作。",
    episodes: 1,
    updatedAt: "2024-01-30",
    views: 6980000,
    hot: false
  },
  {
    id: "chang-feng-du",
    title: "长风渡",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%2C%20elegant%20couple%20in%20traditional%20hanfu%2C%20soft%20golden%20lantern%20light%2C%20warm%20amber%20and%20cream%20tones%2C%20refined%20classical%20aesthetic%2C%20minimal%20elegant%20background%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-changfengdu&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 8.5,
    genres: ["古装", "爱情", "剧情"],
    actors: ["白敬亭", "宋轶", "刘学义"],
    director: "尹涛",
    description: "徉州才女柳玉茹与纨绔子弟顾九思阴差阳错结为夫妻，二人携手历经家国动荡，从懵懂少年成长为守护苍生的栋梁之材，一段温柔治愈的成长图卷。",
    episodes: 40,
    updatedAt: "2024-01-20",
    views: 6210000,
    hot: true
  },
  {
    id: "qu-you-feng-de-di-fang",
    title: "去有风的地方",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Healing%20lifestyle%20drama%20poster%2C%20young%20woman%20in%20linen%20dress%20standing%20in%20sunny%20countryside%20with%20golden%20fields%2C%20warm%20soft%20beige%20and%20sage%20green%20tones%2C%20peaceful%20natural%20light%2C%20minimal%20elegant%20background%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-youfeng&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 8.6,
    genres: ["都市", "治愈", "爱情"],
    actors: ["刘亦菲", "李现", "胡冰卿"],
    director: "丁梓光",
    description: "酒店经理许红豆在挚友离世后独自前往云南云苗村，与返乡创业的谢之遥相遇相知，在慢节奏的乡村生活中重新找到生活的意义，一部治愈系的田园诗。",
    episodes: 40,
    updatedAt: "2024-01-15",
    views: 5840000,
    hot: false
  },
  {
    id: "xiao-shi-de-ta",
    title: "消失的她",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20woman%20silhouette%20reflected%20in%20fragmented%20mirror%2C%20cool%20teal%20and%20deep%20blue%20tones%2C%20tense%20mysterious%20atmosphere%2C%20dramatic%20low%20key%20lighting%2C%20minimal%20dark%20background%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-xiaoshideta&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 6.2,
    genres: ["悬疑", "犯罪", "剧情"],
    actors: ["朱一龙", "倪妮", "文咏珊"],
    director: "崔睿",
    description: "何非的妻子李木子在结婚周年旅行中离奇消失，一个陌生女人却自称是李木子。随着金牌律师陈麦的介入，一场精心设计的骗局逐渐浮出水面。",
    episodes: 1,
    updatedAt: "2024-01-28",
    views: 6530000,
    hot: false
  },
  {
    id: "feng-shen-1",
    title: "封神第一部",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20movie%20poster%2C%20ancient%20warrior%20knight%20in%20bronze%20armor%20with%20epic%20battlefield%20behind%2C%20deep%20gold%20and%20charcoal%20tones%2C%20dramatic%20heroic%20lighting%2C%20grand%20mythological%20atmosphere%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-fengshen&orientation=portrait",
    year: 2023,
    region: "中国大陆",
    rating: 7.8,
    genres: ["奇幻", "神话", "动作"],
    actors: ["费翔", "李雪健", "黄渤"],
    director: "乌尔善",
    description: "殷寿发动政变成为商王，少年姬发在朝歌认清其真面目，踏上归乡之路。恢弘的神话世界观与扎实的视效工业，重新定义华语奇幻史诗。",
    episodes: 1,
    updatedAt: "2024-01-26",
    views: 6120000,
    hot: false
  },
  {
    id: "oppenheimer",
    title: "奥本海默",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%2C%20thoughtful%20man%20in%20vintage%20suit%20before%20glowing%20atomic%20fireball%2C%20warm%20orange%20and%20black%20tones%2C%20dramatic%20cinematic%20lighting%2C%20serious%20historical%20atmosphere%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-oppenheimer&orientation=portrait",
    year: 2023,
    region: "美国",
    rating: 8.9,
    genres: ["传记", "剧情", "历史"],
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙"],
    director: "克里斯托弗·诺兰",
    description: "聚焦原子弹之父罗伯特·奥本海默的传奇一生，从曼哈顿计划的辉煌到战后听证会的煎熬，诺兰用三段式叙事呈现一位天才科学家的道德困境。",
    episodes: 1,
    updatedAt: "2024-02-05",
    views: 7120000,
    hot: true
  },
  {
    id: "spider-verse-2",
    title: "蜘蛛侠：纵横宇宙",
    type: "movie",
    typeName: "电影",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20animated%20superhero%20movie%20poster%2C%20masked%20hero%20leaping%20across%20colorful%20multiverse%20city%2C%20explosive%20red%20blue%20and%20magenta%20comic%20palette%2C%20dynamic%20energetic%20composition%2C%20stylized%20graphic%20art%2C%20premium%20film%20cover%20art&width=600&height=800&seq=poster-spiderverse&orientation=portrait",
    year: 2023,
    region: "美国",
    rating: 8.5,
    genres: ["动画", "动作", "科幻"],
    actors: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    director: "华金·多斯·桑托斯",
    description: "迈尔斯穿越多元宇宙，与格温及蜘蛛侠联盟相遇，却因命运与自由意志的分歧站到对立面。突破性的视觉风格与天马行空的想象力。",
    episodes: 1,
    updatedAt: "2024-02-08",
    views: 5320000,
    hot: false
  },
  {
    id: "langya-bang",
    title: "琅琊榜",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20poster%2C%20scholar%20in%20white%20robe%20holding%20fan%20in%20ancient%20hall%2C%20muted%20ink%20blue%20and%20cream%20tones%2C%20elegant%20classical%20lighting%2C%20refined%20oriental%20aesthetic%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-langyabang&orientation=portrait",
    year: 2015,
    region: "中国大陆",
    rating: 9.4,
    genres: ["古装", "权谋", "剧情"],
    actors: ["胡歌", "刘涛", "王凯"],
    director: "孔笙",
    description: "十二年前冤死的少帅林殊化身谋士梅长苏归来，以病弱之躯搅动金陵风云，辅佐靖王昭雪沉冤。权谋与人情交织的古典叙事范本。",
    episodes: 54,
    updatedAt: "2024-01-10",
    views: 5230000,
    hot: false
  },
  {
    id: "shan-hai-qing",
    title: "山海情",
    type: "tv",
    typeName: "电视剧",
    cover: "https://readdy.ai/api/search-image?query=Realistic%20drama%20poster%2C%20resilient%20farmers%20standing%20on%20arid%20northwest%20loess%20plateau%2C%20warm%20earthy%20ochre%20and%20dusty%20green%20tones%2C%20natural%20sunlight%2C%20sincere%20documentary%20atmosphere%2C%20premium%20streaming%20cover%20art&width=600&height=800&seq=poster-shanhaiqing&orientation=portrait",
    year: 2021,
    region: "中国大陆",
    rating: 9.2,
    genres: ["现实", "剧情", "乡村"],
    actors: ["黄轩", "热依扎", "张嘉益"],
    director: "孔笙",
    description: "上世纪九十年代，西海固移民在戈壁滩上重建家园。从“干沙滩”到“金沙滩”，一段跨越东西部协作扶贫的奋斗史诗，质朴而动人。",
    episodes: 23,
    updatedAt: "2024-01-08",
    views: 4180000,
    hot: false
  },
  {
    id: "ben-pao-ba",
    title: "奔跑吧",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20reality%20variety%20show%20poster%2C%20group%20of%20young%20people%20laughing%20in%20colorful%20outdoor%20setting%2C%20vibrant%20orange%20and%20sky%20blue%20tones%2C%20playful%20fun%20energy%2C%20bright%20cheerful%20lighting%2C%20premium%20show%20cover%20art&width=600&height=800&seq=poster-benpaoba&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 7.2,
    genres: ["真人秀", "竞技", "娱乐"],
    actors: ["李晨", "angelababy", "郑恺"],
    director: "浙江卫视",
    description: "明星嘉宾组成奔跑团，在城市与自然场景中展开趣味竞技与默契考验。轻松欢乐的氛围与不断升级的游戏设计，陪伴观众度过每个周末。",
    episodes: 12,
    updatedAt: "2024-06-20",
    views: 4650000,
    hot: true
  },
  {
    id: "wang-pai",
    title: "王牌对王牌",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Studio%20variety%20show%20poster%2C%20glamorous%20performers%20on%20a%20bright%20colorful%20stage%2C%20vibrant%20magenta%20and%20gold%20tones%2C%20festive%20theatrical%20lighting%2C%20fun%20energetic%20atmosphere%2C%20premium%20TV%20show%20cover%20art&width=600&height=800&seq=poster-wangpai&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 7.5,
    genres: ["棚内综艺", "娱乐", "游戏"],
    actors: ["沈腾", "贾玲", "华晨宇"],
    director: "浙江卫视",
    description: "王牌家族与飞行嘉宾分阵营对抗，通过影视经典重聚、趣味游戏与即兴表演带来欢乐。情怀与笑点齐飞的国民综艺。",
    episodes: 12,
    updatedAt: "2024-05-18",
    views: 3980000,
    hot: false
  },
  {
    id: "sheng-sheng-bu-xi",
    title: "声生不息",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Music%20variety%20show%20poster%2C%20singer%20silhouette%20on%20stage%20with%20warm%20spotlights%20and%20sound%20waves%2C%20deep%20amber%20and%20purple%20tones%2C%20emotional%20concert%20atmosphere%2C%20elegant%20stage%20lighting%2C%20premium%20show%20cover%20art&width=600&height=800&seq=poster-shengsheng&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 8.4,
    genres: ["音乐", "竞演", "文化"],
    actors: ["林子祥", "叶蒨文", "炎明熹"],
    director: "芒果TV",
    description: "两地歌手同台合唱经典金曲，用音乐串联时代记忆与地域文化。专业级的舞台呈现与真挚的情感表达，唤醒一代人的旋律共鸣。",
    episodes: 12,
    updatedAt: "2024-06-28",
    views: 4320000,
    hot: true
  },
  {
    id: "ji-xian-tiao-zhan",
    title: "极限挑战",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20reality%20show%20poster%2C%20group%20of%20friends%20running%20through%20a%20dramatic%20city%20street%2C%20bold%20yellow%20and%20charcoal%20tones%2C%20action%20packed%20dynamic%20energy%2C%20dramatic%20urban%20lighting%2C%20premium%20show%20cover%20art&width=600&height=800&seq=poster-jixian&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 7.0,
    genres: ["真人秀", "挑战", "娱乐"],
    actors: ["黄渤", "孙红雷", "黄磊"],
    director: "东方卫视",
    description: "极限男人帮在真实场景中完成高难度任务与烧脑挑战，展现智慧与情谊的碰撞。走出舒适区的冒险旅程，笑泪交织。",
    episodes: 12,
    updatedAt: "2024-05-30",
    views: 3510000,
    hot: false
  },
  {
    id: "wo-shi-ge-shou",
    title: "我是歌手",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Singing%20competition%20show%20poster%2C%20confident%20singer%20holding%20microphone%20under%20dramatic%20spotlight%2C%20deep%20red%20and%20gold%20tones%2C%20powerful%20emotional%20stage%20atmosphere%2C%20cinematic%20concert%20lighting%2C%20premium%20show%20cover%20art&width=600&height=800&seq=poster-woshigeshou&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 8.0,
    genres: ["音乐", "竞演", "歌唱"],
    actors: ["韩红", "孙楠", "那英"],
    director: "湖南卫视",
    description: "实力唱将同台竞技，用一场场高水准的现场演出征服观众。专业评审与大众投票结合，见证华语乐坛的巅峰对决。",
    episodes: 13,
    updatedAt: "2024-06-10",
    views: 3890000,
    hot: false
  },
  {
    id: "xiang-wang",
    title: "向往的生活",
    type: "variety",
    typeName: "综艺",
    cover: "https://readdy.ai/api/search-image?query=Slow%20life%20variety%20show%20poster%2C%20cozy%20farmhouse%20in%20green%20countryside%20with%20warm%20evening%20light%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20peaceful%20pastoral%20atmosphere%2C%20natural%20warm%20lighting%2C%20premium%20show%20cover%20art&width=600&height=800&seq=poster-xiangwang&orientation=portrait",
    year: 2024,
    region: "中国大陆",
    rating: 7.8,
    genres: ["慢综艺", "生活", "治愈"],
    actors: ["何炅", "黄磊", "彭昱畅"],
    director: "湖南卫视",
    description: "蘑菇屋一家人回归田园，招待来访的老友与客人，一起做饭、闲聊、劳作。远离喧嚣的慢生活，抚慰都市人疲惫的心。",
    episodes: 12,
    updatedAt: "2024-06-15",
    views: 3720000,
    hot: false
  }
];